import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';

import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {RouterModule} from '@angular/router';

import {AppComponent} from './app.component';
import {AccueilComponent} from './accueil/accueil.component';
import {AdminGuardService} from './common/guards/admin-guard.service';
import {BreadcrumbComponent} from './page/breadcrumb/breadcrumb.component';
import {CategoriesComponent} from './accueil/categories/categories.component';
import {CategoriesDetailComponent} from './accueil/categories-list/categories-detail/categories-detail.component';
import {CategoriesListComponent} from './accueil/categories-list/categories-list.component';
import {CategoryComponent} from './accueil/categories/category/category.component';
import {CommentComponent} from './page/comment/comment.component';
import {HeroComponent} from './accueil/hero/hero.component';
import {MatAngularModule} from '@Common/mat-angular.module';
import {PageComponent} from './page/page.component';
import {PageContentComponent} from './page/page-content/page-content.component';
import {ROUTES} from './app.routes';
import {SettingsModule} from './settings/settings.module';
import {TextBlockComponent} from './page/page-content/text-block/text-block.component';
import './rxjs-operators';
import {AppUrlConfig} from '@Services/base';
import {AppUrlConfigImplem} from './del-common/appUrlConfigImplem';
import {CommonModuleP8} from '@Common/common-p8.module';
import {CoreModule} from '@Common/core/core.module';
import {MenuNavFaqComponent} from './del-common/components/menu-faq-navbar';
import {PermissionDeniedComponent} from './del-common/components/permission-denied/permission-denied.component';
import {PubSubService} from './common/services/pub-sub.service';
import {SearchNavComponent} from './common/components/search.component';
import {StatistiquesComponent} from './statistiques/statistiques.component';
import {ImageBlockComponent} from './page/page-content/image-block/image-block.component';
import {PagePreviewComponent} from './settings/pages/page-preview/page-preview.component';
import {DocumentComponent} from './page/document/document.component';
import {SupergestionnaireGuardService} from './common/guards/supergestionnaire-guard.service';
import {GestionnaireGuardService} from './common/guards/gestionnaire-guard.service';
import {CaneditGuardService} from './common/guards/canedit-guard.service';

import {FeedbackComponent} from './common/components/feedback/feedback.component';
import {FeedBackNavComponent} from './common/components/feedback-nav-component';
import {FeedbackContainerComponent} from './common/components/feedback/feedback-container/feedback-container.component';
import {CommonBdcModule} from './common/common-bdc.module';


@NgModule({
    declarations: [
        AccueilComponent,
        AppComponent,
        BreadcrumbComponent,
        CategoriesComponent,
        CategoriesDetailComponent,
        CategoriesListComponent,
        CategoryComponent,
        CommentComponent,
        HeroComponent,
        MenuNavFaqComponent,
        PageComponent,
        PageContentComponent,
        PermissionDeniedComponent,
        SearchNavComponent,
        SearchNavComponent,
        StatistiquesComponent,
        TextBlockComponent,
        ImageBlockComponent,
        PagePreviewComponent,
        DocumentComponent,
        FeedBackNavComponent,
        FeedbackComponent,
        FeedbackContainerComponent,
    ],
    schemas: [NO_ERRORS_SCHEMA],
    imports: [
        BrowserAnimationsModule,
        CommonModule,
        CommonModuleP8,
        CoreModule,
        FormsModule,
        HttpClientModule,
        MatAngularModule,
        ReactiveFormsModule,
        RouterModule.forRoot(ROUTES, {}),
        SettingsModule,
        CommonBdcModule
    ],
    exports: [
        PageComponent
    ],
    providers: [
        AdminGuardService,
        SupergestionnaireGuardService,
        GestionnaireGuardService,
        CaneditGuardService,
        PubSubService,
        { provide: AppUrlConfig, useClass: AppUrlConfigImplem }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
